import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'letter-v', 'LetterV', [["path",{"d":"M6 4l6 16l6 -16"}]]);